export default "__VITE_ASSET__BbIFzG2d__"